import React, { Component } from 'react';
import CountUp, { startAnimation } from 'react-countup';
import VisibilitySensor from 'react-visibility-sensor';


// Components
import { PageSection } from '../PageSection';
import { SectionTitle } from '../generic/SectionTitle';

export class Results extends Component {
    render() {
        // TODO: This one is hard to make into components since each one has a very different layout.

        let sessions;
        let downloads;
        let returningusers;
        let female;
        let reviews;

        var onChange = function (isVisible) {
            if (sessions && isVisible) {
                startAnimation(sessions);
            }
            if (downloads && isVisible) {
                startAnimation(downloads);
            }
            if (returningusers && isVisible) {
                startAnimation(returningusers);
            }
            if (female && isVisible) {
                startAnimation(female);
            }
            if (reviews && isVisible) {
                startAnimation(reviews);
            }
        };

        return (
            <PageSection sectionId="impact-results">
                <VisibilitySensor onChange={onChange} />
                <img src="./images/bg/bg-lower-right-smaller.png" alt="" style={{ position: 'absolute', right: '-80px', bottom: '-120px' }} />

                <SectionTitle>Impact &amp; Results</SectionTitle>

                <div id="results-grid">
                    <div id="results-downloads" className="results-grid-card single">
                        <div className="inner">
                            <img style={{ position: 'absolute', top: '-30px' }} src="./images/results/results-icon-downloads.png" alt="" />
                            <p style={{ paddingTop: '70px' }}>
                                <span className="prominent">
                                <CountUp
                                        start={0}
                                        end={38000}
                                        useEasing={true}
                                        useGrouping={true}
                                        separator=","
                                        prefix="+"
                                        ref={(countUp) => {downloads = countUp;}}
                                    />
                                </span><br/>
                                <span>downloads in total</span>
                            </p>
                        </div>
                    </div>

                    <div id="results-sessions" className="results-grid-card single">
                        <div className="inner">
                            <p>
                                <span className="prominent">
                                    <CountUp
                                        start={0}
                                        end={70000}
                                        useEasing={true}
                                        useGrouping={true}
                                        separator=","
                                        prefix="+"
                                        ref={(countUp) => {sessions = countUp;}}
                                    />
                                </span><br /><span className="prominent prominent--sessions">sessions</span>
                            </p>
                            <div className="subtext">in total</div>
                        </div>
                    </div>

                    <div id="results-reviews" className="results-grid-card single">
                        <div className="inner">
                            <p>
                                <span className="less-prominent">
                                <CountUp
                                        start={0}
                                        end={4.7}
                                        useEasing={true}
                                        decimals={1}
                                        decimal="."
                                        suffix=" "
                                        ref={(countUp) => {reviews = countUp;}}
                                    />
                                 star review</span><br />
                                <img src="./images/results/results-icon-stars.png" alt="" /><br />
                                in both Google Play<br />and App Store
                            </p>
                        </div>
                    </div>

                    <div id="results-sessiontime" className="results-grid-card single">
                        <div className="inner">
                            <p>
                                <img src="./images/results/results-icon-sessiontime.png" alt="" /><br />
                                <span className="prominent">4 min</span><br />
                                Average duration/session
                            </p>
                        </div>
                    </div>

                    <div id="results-globe" className="results-grid-card single">
                        <div className="inner">
                            <p>
                                <span className="less-prominent"><em>Global reach</em></span><br />
                                Downloads<br />in 147 countries
                            </p>
                        </div>
                    </div>

                    <div id="results-female" className="results-grid-card single">
                        <div className="inner">
                            <p>
                                <img style={{ position: 'absolute', top: '20px', right: '-40px' }} src="./images/results/results-icon-female.png" alt="" />
                                <span className="prominent">
                                <CountUp
                                        start={0}
                                        end={46}
                                        useEasing={true}
                                        suffix="%"
                                        ref={(countUp) => {female = countUp;}}
                                    />
                                </span><br />reach of<br /><span className="prominent">female</span>
                            </p>
                        </div>
                    </div>

                    <div id="results-returningusers" className="results-grid-card single">
                        <div className="inner">
                            <img style={{ position: 'absolute', top: '20px', left: '-40px' }} src="./images/results/results-icon-returningusers.png" alt="" />
                            <p>
                                <span className="prominent">
                                <CountUp
                                        start={0}
                                        end={44.5}
                                        useEasing={true}
                                        suffix="%"
                                        decimals={1}
                                        decimal="."
                                        ref={(countUp) => {returningusers = countUp;}}
                                    />
                                </span><br />returning<br /><span className="prominent">users</span>
                            </p>
                        </div>
                    </div>

                    <div id="results-channel9" className="results-grid-card double">
                        <div className="inner">
                            <p>
                                <em>
                                    Covered across a<br />range of media including<br />
                                    <span className="medium-prominent">Today show<br />channel 9</span>
                                </em>
                            </p>
                        </div>
                    </div>
                </div>
            </PageSection>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/sections/Results.jsx